import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        primary: {
            main: '#a52a2a',
        },
        secondary: {
            main: '#28a745',
        },
        background: {
            default: '#f8f9fa',
        },
    },
    typography: {
        fontFamily: 'Roboto, Arial, sans-serif',
    },
});

export default theme;
